import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";
import { toast } from "react-toastify";
import DeleteModal from "../../../../Components/Common/DeleteModal";

import {
  leadPriorityCreate,
  leadPriorityCreateSuccess,
  leadPriorityDelete,
  leadPriorityDeleteSuccess,
  leadPriorityList,
  leadPriorityUpdate,
  leadPriorityUpdateSuccess,
  leadStatusCreate,
  leadStatusCreateSuccess,
  leadStatusDelete,
  leadStatusDeleteSuccess,
  leadStatusList,
  leadStatusUpdate,
  leadStatusUpdateSuccess,
  leadTypeCreate,
  leadTypeCreateSuccess,
  leadTypeDelete,
  leadTypeDeleteSuccess,
  leadTypeList,
  leadTypeUpdate,
  leadTypeUpdateSuccess,
  leadTaskTypeList,
  leadTaskTypeCreate,
  leadTaskTypeCreateSuccess,
  leadTaskTypeUpdate,
  leadTaskTypeUpdateSuccess,
  leadTaskTypeDelete,
  leadTaskTypeDeleteSuccess,
} from "../../../../store/Leads/action";

export default function LeadsSettings() {
  const dispatch = useDispatch();

  const { StatusListApi, TypeList, PriorityList, LeadTaskTypeListApi } =
    useSelector((state) => ({
      StatusListApi: state.leadsReducer.leadStatusList?.leadstatus_list,
      TypeList: state.leadsReducer.leadTypeList?.leadtype_list,
      PriorityList: state.leadsReducer.leadPriorityList?.leadpriority_list,
      LeadTaskTypeListApi:
        state.leadsReducer.leadTaskTypeList?.leadtasktype_list,
    }));

  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [statusFlag, setStatusFlag] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  const [createStatus, setCreateStatus] = useState({
    Name: "New",
    Description: "",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    CssColourBorder: "#1155ff",
    FlagActive: "0",
  });

  const handleCreateNewStatus = () => {
    const createPayload = {
      Name: createStatus?.Name,
      Description: createStatus?.Description || "",
      CssColourText: createStatus?.CssColourText,
      CssColourBackground: createStatus?.CssColourBackground,
      CssColourBorder: createStatus?.CssColourBorder,
      FlagActive: createStatus?.FlagActive,
    };

    if (activeTab === "1") {
      dispatch(leadStatusCreate([createPayload]));
    }

    if (activeTab === "2") {
      dispatch(leadTypeCreate([createPayload]));
    }

    if (activeTab === "3") {
      dispatch(leadPriorityCreate([createPayload]));
    }

    if (activeTab === "4") {
      dispatch(leadTaskTypeCreate([createPayload]));
    }
  };

  useEffect(() => {
    let data = [];

    if (activeTab === "1") {
      data = [...(StatusListApi || [])].sort((a, b) => b.Id - a.Id);
      setStatusFlag(true);
    }

    if (activeTab === "2") {
      data = [...(TypeList || [])].sort((a, b) => b.Id - a.Id);
      setStatusFlag(false);
    }

    if (activeTab === "3") {
      data = [...(PriorityList || [])].sort((a, b) => b.Id - a.Id);
      setStatusFlag(false);
    }

    if (activeTab === "4") {
      data = [...(LeadTaskTypeListApi || [])].sort((a, b) => b.Id - a.Id);
      setStatusFlag(false);
    }

    setStatusList(data);
  }, [activeTab, StatusListApi, TypeList, PriorityList, LeadTaskTypeListApi]);

  useEffect(() => {
    dispatch(leadStatusList());
    dispatch(leadPriorityList());
    dispatch(leadTypeList());
    dispatch(leadTaskTypeList());
  }, []);

  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      dispatch(leadStatusDelete([deleteStatus]));
    }

    if (activeTab === "2") {
      dispatch(leadTypeDelete([deleteStatus]));
    }

    if (activeTab === "3") {
      dispatch(leadPriorityDelete([deleteStatus]));
    }

    if (activeTab === "4") {
      dispatch(leadTaskTypeDelete([deleteStatus]));
    }
  };

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;

    const updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      Description: updateItemStatus?.Description || "",
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourBorder: updateItemStatus?.CssColourBorder,
      CssColourText: updateItemStatus?.CssColourText,
      FlagActive: updateItemStatus?.FlagActive,
      FlagComplete: updateItemStatus?.FlagComplete,
      FlagCallOutbound: updateItemStatus?.FlagCallOutbound,
    };

    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        dispatch(leadStatusUpdate([updateNewStatus]));
      }

      if (activeTab === "2") {
        dispatch(leadTypeUpdate([updateNewStatus]));
      }

      if (activeTab === "3") {
        dispatch(leadPriorityUpdate([updateNewStatus]));
      }

      if (activeTab === "4") {
        dispatch(leadTaskTypeUpdate([updateNewStatus]));
      }

      // Important: clear it so it cannot keep firing update requests
      setUpdateItemStatus({});
    }, 500);

    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  const {
    addNewTaskStatusSuccessAPI,
    updateTaskStatusSuccessAPI,
    deleteTaskStatusSuccessAPI,
  } = useSelector((state) => ({
    addNewTaskStatusSuccessAPI: state.leadsReducer.leadStatusCreateSuccess,
    updateTaskStatusSuccessAPI: state.leadsReducer.leadStatusUpdateSuccess,
    deleteTaskStatusSuccessAPI: state.leadsReducer.leadStatusDeleteSuccess,
  }));

  // Add New Lead Status response
  useEffect(() => {
    if (isEmpty(addNewTaskStatusSuccessAPI)) return;

    if (addNewTaskStatusSuccessAPI?.status === 200) {
      toast.success(addNewTaskStatusSuccessAPI?.message);
      dispatch(leadStatusList());
    } else {
      toast.error(addNewTaskStatusSuccessAPI?.message);
    }

    dispatch(leadStatusCreateSuccess([]));
  }, [addNewTaskStatusSuccessAPI]);

  // Update Lead Status response
  useEffect(() => {
    if (isEmpty(updateTaskStatusSuccessAPI)) return;

    if (updateTaskStatusSuccessAPI?.status === 200) {
      toast.success(updateTaskStatusSuccessAPI?.message);
      dispatch(leadStatusList());
    } else {
      toast.error(updateTaskStatusSuccessAPI?.message);
    }

    dispatch(leadStatusUpdateSuccess([]));
  }, [updateTaskStatusSuccessAPI]);

  // Delete Lead Status response
  useEffect(() => {
    if (isEmpty(deleteTaskStatusSuccessAPI)) return;

    if (deleteTaskStatusSuccessAPI?.status === 200) {
      toast.success(deleteTaskStatusSuccessAPI?.message);
      dispatch(leadStatusList());
      setDeleteModal(false);
      setDeleteStatus("");
    } else {
      toast.error(deleteTaskStatusSuccessAPI?.message);
    }

    dispatch(leadStatusDeleteSuccess([]));
  }, [deleteTaskStatusSuccessAPI]);

  const {
    addNewTaskTypeSuccessAPI,
    updateTaskTypeSuccessAPI,
    deleteTaskTypeSuccessAPI,
  } = useSelector((state) => ({
    addNewTaskTypeSuccessAPI: state.leadsReducer.leadTypeCreateSuccess,
    updateTaskTypeSuccessAPI: state.leadsReducer.leadTypeUpdateSuccess,
    deleteTaskTypeSuccessAPI: state.leadsReducer.leadTypeDeleteSuccess,
  }));

  // Add New Lead Type response
  useEffect(() => {
    if (isEmpty(addNewTaskTypeSuccessAPI)) return;

    if (addNewTaskTypeSuccessAPI?.status === 200) {
      toast.success(addNewTaskTypeSuccessAPI?.message);
      dispatch(leadTypeList());
    } else {
      toast.error(addNewTaskTypeSuccessAPI?.message);
    }

    dispatch(leadTypeCreateSuccess([]));
  }, [addNewTaskTypeSuccessAPI]);

  // Update Lead Type response
  useEffect(() => {
    if (isEmpty(updateTaskTypeSuccessAPI)) return;

    if (updateTaskTypeSuccessAPI?.status === 200) {
      toast.success(updateTaskTypeSuccessAPI?.message);
      dispatch(leadTypeList());
    } else {
      toast.error(updateTaskTypeSuccessAPI?.message);
    }

    dispatch(leadTypeUpdateSuccess([]));
  }, [updateTaskTypeSuccessAPI]);

  // Delete Lead Type response
  useEffect(() => {
    if (isEmpty(deleteTaskTypeSuccessAPI)) return;

    if (deleteTaskTypeSuccessAPI?.status === 200) {
      toast.success(deleteTaskTypeSuccessAPI?.message);
      dispatch(leadTypeList());
      setDeleteModal(false);
      setDeleteStatus("");
    } else {
      toast.error(deleteTaskTypeSuccessAPI?.message);
    }

    dispatch(leadTypeDeleteSuccess([]));
  }, [deleteTaskTypeSuccessAPI]);

  const {
    addNewTaskPrioritySuccessAPI,
    updateTaskPrioritySuccessAPI,
    deleteTaskPrioritySuccessAPI,
  } = useSelector((state) => ({
    addNewTaskPrioritySuccessAPI: state.leadsReducer.leadPriorityCreateSuccess,
    updateTaskPrioritySuccessAPI: state.leadsReducer.leadPriorityUpdateSuccess,
    deleteTaskPrioritySuccessAPI: state.leadsReducer.leadPriorityDeleteSuccess,
  }));

  // Add New Lead Priority response
  useEffect(() => {
    if (isEmpty(addNewTaskPrioritySuccessAPI)) return;

    if (addNewTaskPrioritySuccessAPI?.status === 200) {
      toast.success(addNewTaskPrioritySuccessAPI?.message);
      dispatch(leadPriorityList());
    } else {
      toast.error(addNewTaskPrioritySuccessAPI?.message);
    }

    dispatch(leadPriorityCreateSuccess([]));
  }, [addNewTaskPrioritySuccessAPI]);

  // Update Lead Priority response
  useEffect(() => {
    if (isEmpty(updateTaskPrioritySuccessAPI)) return;

    if (updateTaskPrioritySuccessAPI?.status === 200) {
      toast.success(updateTaskPrioritySuccessAPI?.message);
      dispatch(leadPriorityList());
    } else {
      toast.error(updateTaskPrioritySuccessAPI?.message);
    }

    dispatch(leadPriorityUpdateSuccess([]));
  }, [updateTaskPrioritySuccessAPI]);

  // Delete Lead Priority response
  useEffect(() => {
    if (isEmpty(deleteTaskPrioritySuccessAPI)) return;

    if (deleteTaskPrioritySuccessAPI?.status === 200) {
      toast.success(deleteTaskPrioritySuccessAPI?.message);
      dispatch(leadPriorityList());
      setDeleteModal(false);
      setDeleteStatus("");
    } else {
      toast.error(deleteTaskPrioritySuccessAPI?.message);
    }

    dispatch(leadPriorityDeleteSuccess([]));
  }, [deleteTaskPrioritySuccessAPI]);

  const {
    addNewLeadTaskTypeSuccessAPI,
    updateLeadTaskTypeSuccessAPI,
    deleteLeadTaskTypeSuccessAPI,
  } = useSelector((state) => ({
    addNewLeadTaskTypeSuccessAPI: state.leadsReducer.leadTaskTypeCreateSuccess,
    updateLeadTaskTypeSuccessAPI: state.leadsReducer.leadTaskTypeUpdateSuccess,
    deleteLeadTaskTypeSuccessAPI: state.leadsReducer.leadTaskTypeDeleteSuccess,
  }));

  // Add New Lead Task Type response
  useEffect(() => {
    if (isEmpty(addNewLeadTaskTypeSuccessAPI)) return;

    if (addNewLeadTaskTypeSuccessAPI?.status === 200) {
      toast.success(addNewLeadTaskTypeSuccessAPI?.message);
      dispatch(leadTaskTypeList());
    } else {
      toast.error(addNewLeadTaskTypeSuccessAPI?.message);
    }

    dispatch(leadTaskTypeCreateSuccess([]));
  }, [addNewLeadTaskTypeSuccessAPI]);

  // Update Lead Task Type response
  useEffect(() => {
    if (isEmpty(updateLeadTaskTypeSuccessAPI)) return;

    if (updateLeadTaskTypeSuccessAPI?.status === 200) {
      toast.success(updateLeadTaskTypeSuccessAPI?.message);
      dispatch(leadTaskTypeList());
    } else {
      toast.error(updateLeadTaskTypeSuccessAPI?.message);
    }

    dispatch(leadTaskTypeUpdateSuccess([]));
  }, [updateLeadTaskTypeSuccessAPI]);

  // Delete Lead Task Type response
  useEffect(() => {
    if (isEmpty(deleteLeadTaskTypeSuccessAPI)) return;

    if (deleteLeadTaskTypeSuccessAPI?.status === 200) {
      toast.success(deleteLeadTaskTypeSuccessAPI?.message);
      dispatch(leadTaskTypeList());
      setDeleteModal(false);
      setDeleteStatus("");
    } else {
      toast.error(deleteLeadTaskTypeSuccessAPI?.message);
    }

    dispatch(leadTaskTypeDeleteSuccess([]));
  }, [deleteLeadTaskTypeSuccessAPI]);

  const renderStatusComponent = () => (
    <StatusViewEditComponent
      statusList={statusList}
      setStatusList={setStatusList}
      createStatus={createStatus}
      setCreateStatus={setCreateStatus}
      handleCreateNewStatus={handleCreateNewStatus}
      setDeleteStatus={setDeleteStatus}
      setDeleteModal={setDeleteModal}
      setUpdateItemStatus={setUpdateItemStatus}
      statusFlag={statusFlag}
    />
  );

  const Tabs = [
    {
      id: "1",
      name: "Statuses",
      content: renderStatusComponent(),
    },
    {
      id: "2",
      name: "Types",
      content: renderStatusComponent(),
    },
    {
      id: "3",
      name: "Priorities",
      content: renderStatusComponent(),
    },
    {
      id: "4",
      name: "Lead Task Types",
      content: renderStatusComponent(),
    },
  ];

  return (
    <>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteStatus}
        onCloseClick={() => {
          setDeleteModal(false);
        }}
      />

      <SettingsPanel
        title="Leads Settings"
        description="Statuses, types, priorities and task types for leads."
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        <div className="tab-content">
          {Tabs.find((item) => item.id === activeTab)?.content}
        </div>
      </SettingsPanel>
    </>
  );
}
